import { createStore } from '@ngneat/elf';
import {
  deleteAllEntities,
  getAllEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';
import { Injectable } from '@angular/core';

import { ID } from '@state/base';
import { FundMessage } from './fund-message.model';

export const fundMessagesStore$ = createStore(
  { name: 'fund-messages' },
  withEntities<FundMessage>()
);

@Injectable({ providedIn: 'root' })
export class FundMessagesRepository {
  messages$ = fundMessagesStore$.pipe(selectAllEntities());

  getAll(): FundMessage[] {
    return fundMessagesStore$.query(getAllEntities());
  }

  reset(): void {
    fundMessagesStore$.update(deleteAllEntities());
  }

  setFundMessages(fundMessages: FundMessage[]): void {
    fundMessagesStore$.update(setEntities(fundMessages));
  }

  updateFundMessage(id: ID, update: Partial<FundMessage>): void {
    fundMessagesStore$.update(updateEntities(id, update));
  }
}
